// PRODUCT_CATEGORY TYPES
export const ProductCategoryTypesData = {
    VEHICLE: 'Vehicle',
    VEHICLE_RTO: 'Vehicle RTO',
    // PERSONAL_INSURANCE: 'PERSONAL_INSURANCE',
    VEHICLE_INSURANCE: 'Insurance',
    CAR_LOAN: 'Car Loan',
    // OTHER_CATEGORY: 'Other Category',
    // LOAN: 'LOAN',
};

export const PRODUCT_CATEGORY_TYPES = {};

export const PRODUCT_CATEGORY_TYPES_LIST = Object.keys(
    ProductCategoryTypesData,
).map((key) => {
    PRODUCT_CATEGORY_TYPES[key] = key;

    return {
        value: key,
        label: ProductCategoryTypesData[key],
    };
});
//Insurance_Plans_Types
// const InsurancePlansTypeData = {
//     NORMAL_INSURANCE: 'Normal Insurance',
//     DEPP_0: '0% DEPP',
//     DEPP_0_CONSUMABLES: '0% DEPP + Consumables',
//     DEPP_0_CONSUMABLES_TYRE_ENGINE: '0% DEPP + Consumables + Tyre + Engine',
//     DEPP_0_CONSUMABLES_ENGINE: '0% DEPP + Consumables + Engine',
//     DEPP_0_CONSUMABLES_TYRE: '0% DEPP + Consumables + Tyre',
//     DEPP_0_CONSUMABLES_TYRE_ENGINE_RTI: '0% DEPP + Consumables + Tyre + Engine + RTI',
// };

// export const INSURANCE_TYPES = {};
// export const INSURANCE_TYPES_LIST = Object.keys(InsurancePlansTypeData).map((key) =>{
//     INSURANCE_TYPES[key] = key;
//     return {
//         value : key,
//         label : InsurancePlansTypeData[key]
//     }
// });

//RC TRANSFERRED BY
const rcTransferredByTypeData = {
    DSA: 'Assigned Agent/Sub DSA',
    RTO_AGENT: 'Autonet(RTO Agent)',
    USED_CAR_DEALER: 'Used Car dealer',
    CUSTOMER: 'Customer',
  };
  
  export const RC_TRANSFERRED_BY_TYPES = {};
  export const RC_TRANSFERRED_BY_TYPES_LIST = Object.keys(rcTransferredByTypeData).map((key) => {
    RC_TRANSFERRED_BY_TYPES[key] = key;
    return {
      value: key,
      label: rcTransferredByTypeData[key],
    };
  });
// CC TYPES
const CCTypesData = {
    BELOW_1000_CC: 'Below 1000 CC',
    FROM_1000_TO_1500_CC: '1000 to 1500 CC',
    ABOVE_1500: 'Above 1500 CC',
};

export const CC_TYPES = {};

export const CC_TYPES_LIST = Object.keys(CCTypesData).map((key) => {
    CC_TYPES[key] = key;

    return {
        value: key,
        label: CCTypesData[key],
    };
});

// FUEL TYPES
const FuelTypesData = {
    PETROL: 'Petrol',
    DIESEL: 'Diesel',
    CNG: 'CNG',
    ELECTRIC: 'Electric',
    ETHANOL: 'Ethanol',
    OTHERS: 'Others'

};

export const FUEL_TYPES = {};

export const FUEL_TYPES_LIST = Object.keys(FuelTypesData).map((key) => {
    FUEL_TYPES[key] = key;

    return {
        value: key,
        label: FuelTypesData[key],
    };
});

// VEHICLE AGE
const VehicleStatusTypesData = {
    NEW: 'New',
    NEW_ROLLOVER: 'New-Rollover',
    RENEWAL: 'Renewal',
    ROLLOVER: 'Rollover',
};

export const VEHICLE_STATUS_TYPES = {};

export const VEHICLE_STATUS_TYPES_LIST = Object.keys(
    VehicleStatusTypesData,
).map((key) => {
    VEHICLE_STATUS_TYPES[key] = key;

    return {
        value: key,
        label: VehicleStatusTypesData[key],
    };
});

// VEHICLE ORIGIN ZONE
const VehicleOriginTypesData = {
    SAME_ZONE: 'Same Zone',
    OTHER_ZONE: 'Other Zone',
};

export const VEHICLE_ORIGIN_TYPES = {};

export const VEHICLE_ORIGIN_TYPES_LIST = Object.keys(
    VehicleOriginTypesData,
).map((key) => {
    VEHICLE_ORIGIN_TYPES[key] = key;

    return {
        value: key,
        label: VehicleOriginTypesData[key],
    };
});

//Car Loan Type
const CarLoanType = {
    NEW: 'New',
    USED: 'Used'
};

export const CAR_LOAN_TYPE = {};
export const CAR_LOAN_TYPE_LIST = Object.keys(
    CarLoanType,
).map((key) => {
    CAR_LOAN_TYPE[key] = key;

    return {
        value: key,
        label: CarLoanType[key],
    };
});

//Used Car Loan Type
const UsedCarLoanType = {
    SALE_PURCHASE: 'Sale-Purchase',
    RE_FINANCE: 'Re-Finance',
    BALANCE_TRANSFER: 'Balance Transfer',
    TOP_UP: 'BT Top Up',
    INTERNAL_BT:'Internal BT'
};
export const USED_CAR_LOAN_TYPE = {};
export const USED_CAR_LOAN_TYPE_LIST = Object.keys(
    UsedCarLoanType,
).map((key) => {
    USED_CAR_LOAN_TYPE[key] = key;

    return {
        value: key,
        label: UsedCarLoanType[key],
    };
});

//Source
const SourceType = {
    UNDEFINED: 'UnDefined ',
    IN_HOUSE: 'In-House',
    DSA: 'DSA',
    THIRD_PARTY: 'Third Party'
};
export const SOURCE_TYPE = {};
export const SOURCE_TYPE_LIST = Object.keys(
    SourceType,
).map((key) => {
    SOURCE_TYPE[key] = key;

    return {
        value: key,
        label: SourceType[key],
    };
});


// PRODUCT_CATEGORY TYPES
const PaymentModeTypesData = {
    CHEQUE: 'Cheque',
    NEFT_RTGS: 'NEFT/RTGS',
    DD: 'DD',
    UPI: 'UPI',
    CASH: 'Cash'
};

export const PAYMENT_MODE_TYPES = {};

export const PAYMENT_MODE_TYPES_LIST = Object.keys(
    PaymentModeTypesData,
).map((key) => {
    PAYMENT_MODE_TYPES[key] = key;

    return {
        value: key,
        label: PaymentModeTypesData[key],
    };
});

// PAYMENT TYPES
const PaymentTypesData = {
    Advance_Payment: 'Advance Payment',
    Commission_Payment: 'Commission Payment',
    Other: 'Other',
};

export const PAYMENT_TYPES = {};

export const PAYMENT_TYPES_LIST = Object.keys(
    PaymentTypesData,
).map((key) => {
    PAYMENT_TYPES[key] = key;

    return {
        value: key,
        label: PaymentTypesData[key],
    };
});


// DAYS_LEFT TYPES
export const DaysLeftTypesData = {
    DAYS_30: '30 Days',
    DAYS_60: '60 Days',
};

export const DAYS_LEFT_TYPES = {};

export const DAYS_LEFT_TYPES_LIST = Object.keys(DaysLeftTypesData).map((key) => {
    DAYS_LEFT_TYPES[key] = key;

    return {
        value: key,
        label: DaysLeftTypesData[key],
    };
});

//DAYS_COUNT
export const DaysCountTypesData = {
    ascending : 'Smaller to larger',
    descending : 'Larger to smaller',
};

export const DAYS_COUNT_TYPES = {};

export const DAYS_COUNT_TYPES_LIST = Object.keys(DaysCountTypesData).map((key) => {
    DAYS_COUNT_TYPES[key] = key;

    return {
        value: key,
        label: DaysCountTypesData[key],
    };
});

// RC TYPES
const RCTypesData = {
    TO: 'TO (TRANSFER OWNERSHIP)',
    HPA: 'HPA (HP ADDITION)',
    HPT: 'HPT (HP TERMINATION)',
    HPT_HPA: 'HPT + HPA',
    TO_HPT_HPA: 'TO + HPT+ HPA',
    TO_HPT_HPA_CO: 'TO + HPT+ HPA+ C/O',
    STATE_NOC: 'STATE NOC',
    TO_CO: 'TO + C/O',
    TO_HPA_STATE_NOC: 'TO + HPA + STATE NOC',
    HPT_HPA_WAP: 'HPT + HPA (WITHOUT ADDRESS PROOF)',
    DC_DUPLICATE_RC: 'DC  (DUPLICATE RC)',
    TO_HPT_HPA_DC: 'TO + HPT + HPA + DC',
    HPT_HPA_WITHOUT_RC: 'HPT + HPA (WITHOUT RC)',
    TO_HPT_HPA_DOE: 'TO + HPT + HPA + DOE',
    TO_HPA_DOE: 'TO + HPA + DOE',
    HPT_HPA_DOE: 'HPT + HPA + DOE',
};

export const RC_TYPES = {};

export const RC_TYPES_LIST = Object.keys(RCTypesData).map((key) => {
    RC_TYPES[key] = key;

    return {
        value: key,
        label: RCTypesData[key],
    };
});

//NCB
const NCBType = {
    0: '0',
    1: 'Greater then 0',
};

export const NCB_TYPE = {};
export const NCB_TYPE_LIST = Object.keys(
    NCBType
).map((key) => {
    NCB_TYPE[key] = key;

    return {
        value: key,
        label: NCBType[key],
    };
});

export default {
    PRODUCT_CATEGORY_TYPES,
    PRODUCT_CATEGORY_TYPES_LIST,
    ProductCategoryTypesData,
    
    // INSURANCE_TYPES,
    // INSURANCE_TYPES_LIST,
    // InsurancePlansTypeData,

    RC_TRANSFERRED_BY_TYPES,
    RC_TRANSFERRED_BY_TYPES_LIST,
    rcTransferredByTypeData,

    CC_TYPES,
    CC_TYPES_LIST,

    FUEL_TYPES,
    FUEL_TYPES_LIST,

    VEHICLE_STATUS_TYPES,
    VEHICLE_STATUS_TYPES_LIST,

    VEHICLE_ORIGIN_TYPES,
    VEHICLE_ORIGIN_TYPES_LIST,

    CAR_LOAN_TYPE,
    CAR_LOAN_TYPE_LIST,

    USED_CAR_LOAN_TYPE,
    USED_CAR_LOAN_TYPE_LIST,

    SOURCE_TYPE,
    SOURCE_TYPE_LIST,

    PAYMENT_MODE_TYPES,
    PAYMENT_MODE_TYPES_LIST,

    PAYMENT_TYPES,
    PAYMENT_TYPES_LIST,

    DAYS_LEFT_TYPES,
    DAYS_LEFT_TYPES_LIST,
    DaysLeftTypesData,

    DAYS_COUNT_TYPES,
    DAYS_COUNT_TYPES_LIST,
    DaysCountTypesData,

    RC_TYPES,
    RCTypesData,
    RC_TYPES_LIST,

    NCB_TYPE,
    NCBType,
    NCB_TYPE_LIST,

};
